import { Autocomplete, TextField } from "@mui/material";
import React, { useState } from "react";
import { TerrenoArray } from "../../../Arrays/TerrenoArray";
import { SeguroCosechaArray } from "../../../Arrays/SeguroCosechaArray";
import { TipoRiegoArray } from "../../../Arrays/TipoRiegoArray";
import { TemporalArray } from "../../../Arrays/TemporalArray";
import { MesCosechaArray } from "../../../Arrays/MesCosechaArray";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValidaCultivo } from "./ValidaCultivo";

import { useEffect } from "react";
import { useSelector } from "react-redux";

export const ModalCultivoScreen = ({ registro, setcultivos }) => {
  const { idcliente } = useSelector((store) => store.clientes);
  const closedModal = () => {
    var modal = document.getElementById("modal-cultivo");
    modal.style.display = "none";
  };
  const [state, setState] = useState({
    idcultivo: "",
    terreno: "",
    hectareas: "",
    seguro_cosecha: "",
    ciclo: "",
    tipo_riego: "",
    temporal: "",
    rendimiento: "",
    precio: "",
    mescosecha: "",
    estatus: true,
  });
  const [cultivosarray, setCultivosarray] = useState([]);
  const onGuardar = () => {
    var valido = ValidaCultivo(state);
    if (valido !== false) {
      valido.idcliente = Number(idcliente);
      valido.registro = Number(registro);
      request
        .post("ClientesCultivo", valido)
        .then(async (result) => {
          await Swal.fire("Clientes", result.mensaje, "success");
          setcultivos(result.listado);
          setState({
            idcultivo: "",
            terreno: "",
            hectareas: "",
            seguro_cosecha: "",
            ciclo: "",
            tipo_riego: "",
            temporal: "",
            rendimiento: "",
            precio: "",
            mescosecha: "",
            estatus: true,
          });
          closedModal();
        })
        .catch((error) => {
          Swal.fire("Clientes", JSON.stringify(error), "error");
        });
    }
  };
  useEffect(() => {
    request
      .get(`Cultivos/DropDownList`)
      .then((result) => setCultivosarray(result))
      .catch((error) => {
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  }, []);
  useEffect(() => {
    if (registro !== undefined && registro !== null && Number(registro) > 0) {
      request
        .get(
          `ClientesCultivo/ObtenerporOrden?idcliente=${Number(
            idcliente
          )}&registro=${Number(registro)}`
        )
        .then((result) => {
          setState({
            idcultivo: `${result.idcultivo} - ${result.cultivo}`,
            terreno: result.terreno,
            hectareas: result.hectareas,
            seguro_cosecha: result.seguro_cosecha,
            ciclo: result.ciclo,
            tipo_riego: result.tipo_riego,
            temporal: result.temporal,
            rendimiento: result.rendimiento,
            precio: result.precio,
            mescosecha: result.mescosecha,
          });
        })
        .catch((error) => {
          Swal.fire("Clientes", JSON.stringify(error), "error");
        });
    }
  }, [registro]);
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  };
  return (
    <div id="modal-cultivo" class="modal">
      <div class="modal-content-clientes">
        <div class="modal-header-cultivo">
          <span class="close" onClick={closedModal}>
            &times;
          </span>
          <div className="encabezado">
            <div className="titulo">
              {Number(registro) > 0
                ? "ACTUALIZAR CULTIVO"
                : "REGISTRAR CULTIVO"}
            </div>
            <div className="border-green"></div>
          </div>
        </div>
        <div class="modal-body-clientes">
          <Autocomplete
            size="small"
            id="idcultivo"
            freeSolo
            className="mb-15 w-50 "
            value={state.idcultivo}
            onChange={({ target }) =>
              setState({ ...state, idcultivo: target.outerText })
            }
            options={cultivosarray.map(
              (option) => `${option.id} - ${option.display}`
            )}
            renderInput={(params) => <TextField {...params} label="Cultivo" />}
            sx={{ mr: 1 }}
          />
          <div className="col-2-cultivos">
            <Autocomplete
              size="small"
              id="terreno"
              freeSolo
              className="mb-15 w-50"
              value={state.terreno}
              onChange={({ target }) =>
                setState({ ...state, terreno: target.outerText })
              }
              options={TerrenoArray.map(
                (option) => `${option.id} - ${option.display}`
              )}
              renderInput={(params) => (
                <TextField {...params} label="Terreno" />
              )}
            />
            <TextField
              fullWidth
              label="Hectareas"
              size="small"
              color="success"
              className="w-50"
              type="number"
              value={state.hectareas}
              onChange={({ target }) =>
                setState({
                  ...state,
                  hectareas: target.value.toUpperCase(),
                })
              }
              inputProps={{
                maxLength: 50,
              }}
            />
          </div>

          <div className="col-2-cultivos">
            <Autocomplete
              size="small"
              id="segurocosecha"
              freeSolo
              className="mb-15 w-50"
              value={state.seguro_cosecha}
              onChange={({ target }) =>
                setState({ ...state, seguro_cosecha: target.outerText })
              }
              options={SeguroCosechaArray.map(
                (option) => `${option.id} - ${option.display}`
              )}
              renderInput={(params) => (
                <TextField {...params} label="Seguro de Cosecha" />
              )}
              sx={{ mr: 1 }}
            />
            <TextField
              fullWidth
              label="Ciclo"
              size="small"
              color="success"
              className="w-50"
              value={state.ciclo}
              onChange={({ target }) =>
                setState({
                  ...state,
                  ciclo: target.value.toUpperCase(),
                })
              }
              inputProps={{
                maxLength: 20,
              }}
            />
          </div>
          <div className="col-2-cultivos">
            <Autocomplete
              size="small"
              id="tiporiego"
              freeSolo
              className="mb-15 w-50 "
              value={state.tipo_riego}
              onChange={({ target }) =>
                setState({ ...state, tipo_riego: target.outerText })
              }
              options={TipoRiegoArray.map(
                (option) => `${option.id} - ${option.display}`
              )}
              renderInput={(params) => (
                <TextField {...params} label="Tipo de Riego" />
              )}
              sx={{ mr: 1 }}
            />

            <Autocomplete
              size="small"
              id="temporal"
              freeSolo
              className="mb-15 w-50"
              value={state.temporal}
              onChange={({ target }) =>
                setState({ ...state, temporal: target.outerText })
              }
              options={TemporalArray.map(
                (option) => `${option.id} - ${option.display}`
              )}
              renderInput={(params) => (
                <TextField {...params} label="Temporal" />
              )}
              sx={{ mr: 1 }}
            />
          </div>
          <div className="col-2-cultivos">
            <TextField
              fullWidth
              label="Rendimiento Toneladas por Hectareas"
              size="small"
              color="success"
              className="w-50"
              value={state.rendimiento}
              onChange={({ target }) =>
                setState({
                  ...state,
                  rendimiento: target.value.toUpperCase(),
                })
              }
              inputProps={{
                maxLength: 50,
              }}
            />

            <TextField
              fullWidth
              label="Precio por Toneladas"
              size="small"
              color="success"
              className="w-50"
              value={state.precio}
              onChange={({ target }) =>
                setState({
                  ...state,
                  precio: target.value.toUpperCase(),
                })
              }
              inputProps={{
                maxLength: 50,
              }}
            />
          </div>
          <Autocomplete
            fullWidth
            size="small"
            id="mescosecha"
            freeSolo
            className="mb-15"
            value={state.mescosecha}
            onChange={({ target }) =>
              setState({ ...state, mescosecha: target.outerText })
            }
            options={MesCosechaArray.map(
              (option) => `${option.id} - ${option.display}`
            )}
            renderInput={(params) => (
              <TextField {...params} label="Mes de Cosecha" />
            )}
            sx={{ mr: 1 }}
          />
        </div>
        <div className="footer-guardar-cultivo">
          <div className="button-guardar" onClick={onGuardar}>
            Guardar
          </div>
        </div>
      </div>
    </div>
  );
};
